import { FC } from 'react';
import {
  FormControl,
  FormLabel,
  Input,
  Stack,
  ModalOverlay,
  ModalContent,
  ModalHeader,
  ModalCloseButton,
  ModalBody,
  ModalFooter,
  Button,
  Modal,
  Text,
  Flex,
  Box,
  Heading,
} from '@chakra-ui/react';
import { createConditionName } from 'types/releaseTask';
import { ReadonlyCustomerList } from 'components/organisms/ReadonlyCustomerList';
import { useDeleteStore } from '../../hooks';

type Props = ReturnType<typeof useDeleteStore>;

export const TaskDeleteModalView: FC<Props> = ({
  values,
  isOpenModal,
  onCloseModal,
  onDeleteTask,
  shouldShowCustomerList,
  selectedCustomers,
}) => (
  <Modal
    isOpen={isOpenModal}
    onClose={onCloseModal}
    size="2xl"
    blockScrollOnMount
  >
    <ModalOverlay />
    <ModalContent>
      <ModalHeader p="40px">タスクの削除</ModalHeader>
      <ModalCloseButton />
      <ModalBody px="40px">
        <Stack spacing="6" direction="column">
          <FormControl>
            <FormLabel>タスク名</FormLabel>
            <Input
              type="text"
              value={values.taskName}
              width="240px"
              variant="flushed"
              isReadOnly
              isTruncated
            />
          </FormControl>
          <Flex flexDirection="row" gap={5} alignItems="start">
            <Box>
              <FormControl>
                <FormLabel>タスク開始日</FormLabel>
                <Input
                  type="text"
                  value={values.startsAt.substring(0, 10)}
                  width="240px"
                  variant="flushed"
                  isReadOnly
                  isTruncated
                />
              </FormControl>
            </Box>
            <Box w="20px" pt="40px">
              <Text as="span">〜</Text>
            </Box>
            <Box>
              <FormControl>
                <FormLabel>タスク終了日</FormLabel>
                <Input
                  type="text"
                  value={values.endsAt.substring(0, 10)}
                  width="240px"
                  variant="flushed"
                  isReadOnly
                  isTruncated
                />
              </FormControl>
            </Box>
          </Flex>
          <FormControl>
            <FormLabel>ターゲットグループ</FormLabel>
            <Input
              type="text"
              value={values.group}
              variant="flushed"
              isReadOnly
              isTruncated
            />
          </FormControl>
          <Box mt="40px">
            <Heading as="h5" size="sm">
              配信対象顧客
            </Heading>
            <Text fontSize="md">{createConditionName(values.condition)}</Text>
          </Box>
          <Box mt="40px">
            {shouldShowCustomerList && (
              <ReadonlyCustomerList
                selectedCustomers={selectedCustomers}
                selectedCustomersLength={selectedCustomers.length}
              />
            )}
          </Box>
        </Stack>
        <Text mt="60px" align="center" fontWeight="bold">
          上記のタスク情報を削除しますか？
        </Text>
      </ModalBody>
      <ModalFooter gap="16px" justifyContent="center" p="40px">
        <Button
          w="140px"
          colorScheme="blackAlpha"
          variant="outline"
          onClick={onCloseModal}
        >
          キャンセル
        </Button>
        <Button colorScheme="red" onClick={onDeleteTask} w="140px">
          削除
        </Button>
      </ModalFooter>
    </ModalContent>
  </Modal>
);
